module.exports = {"id":"201043","name":"Brecht Dejaegere","rating":"74","photo":"./data/images/photos/3/201043.png","club":{"name":"KAA La Gantoise","logo":"./data/images/clubs/KAALaGantoise.png"},"positions":["MC","MD","MG"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/BrechtDejaegere0.json
// module id = 644
// module chunks = 0